import { c as _c } from "react/compiler-runtime";
import { FormInput, PaymentProcessorEnum, PrimaryButton, getPaymentProcessorTitle } from '@systemeio/ui';
import HelpCenterLink from 'modules/profile/payment-gateways/components/help-center-link';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { paypalConnect } from 'modules/profile/payment-gateways/integrations/paypal-soap/api';
import { PaymentPaypalInterface } from 'modules/profile/payment-gateways/integrations/paypal-soap/types';
import { getPaypalHelpPageLink } from 'modules/profile/payment-gateways/integrations/paypal-soap/utils';
import React, { useState } from 'react';
import CreateModal from 'shared/components/create-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
const defaultValues: PaymentPaypalInterface = {
  username: '',
  password: '',
  signature: ''
};
const defaultErrors: PaymentPaypalInterface = {
  username: '',
  password: '',
  signature: ''
};
const PaypalCreateModal = () => {
  const $ = _c(38);
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const {
    mutatePaymentIntegrations
  } = useConnectedPaymentIntegrations();
  const [errors, setErrors] = useState(defaultErrors);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] !== mutatePaymentIntegrations) {
    t0 = async data => {
      await fetchWithErrors(async () => {
        await paypalConnect(data);
        await mutatePaymentIntegrations();
      }, setErrors);
    };
    $[0] = mutatePaymentIntegrations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onCreate = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      e.preventDefault();
      setOpened(true);
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("dashboard.settings.payment_gateways.connect");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <PrimaryButton onClick={t1} className="font-bold">{t2}</PrimaryButton>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("dashboard.settings.payment_gateways.connect_payment_title", {
      payment: getPaymentProcessorTitle(PaymentProcessorEnum.PaypalSoap)
    });
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpened(false);
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = user?.dashboardLocale;
  let t7;
  if ($[10] !== t6) {
    t7 = getPaypalHelpPageLink(t6);
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = getPaymentProcessorTitle(PaymentProcessorEnum.PaypalSoap);
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7) {
    t9 = <HelpCenterLink link={t7} integration={t8} />;
    $[13] = t7;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== errors || $[16] !== t) {
    t10 = {
      field: "username",
      onRender: (value, onChange) => <FormInput key="paypal-username-create" label={t("global.username")} value={value} onChange={e_0 => onChange(e_0.target.value)} error={errors.username} />
    };
    $[15] = errors;
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== errors || $[19] !== t) {
    t11 = {
      field: "password",
      onRender: (value_0, onChange_0) => <FormInput key="paypal-password-create" label={t("global.password")} value={value_0} onChange={e_1 => onChange_0(e_1.target.value)} error={errors.password} />
    };
    $[18] = errors;
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== errors || $[22] !== t) {
    t12 = {
      field: "signature",
      onRender: (value_1, onChange_1) => <FormInput key="paypal-signature-create" label={t("dashboard.settings.payment_gateways.signature")} value={value_1} onChange={e_2 => onChange_1(e_2.target.value)} error={errors.signature} />
    };
    $[21] = errors;
    $[22] = t;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t12) {
    t13 = [t10, t11, t12];
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = ["username", "password", "signature"];
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== onCreate || $[30] !== opened || $[31] !== t13 || $[32] !== t4 || $[33] !== t9) {
    t15 = <CreateModal fullCaption={t4} opened={opened} onClose={t5} needToast={false} additionalInfo={t9} defaultValues={defaultValues} creatable={t13} onCreate={onCreate} requiredFields={t14} />;
    $[29] = onCreate;
    $[30] = opened;
    $[31] = t13;
    $[32] = t4;
    $[33] = t9;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t15 || $[36] !== t3) {
    t16 = <>{t3}{t15}</>;
    $[35] = t15;
    $[36] = t3;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  return t16;
};
export default PaypalCreateModal;